import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@knockrentals/knock-react';
import { Formik } from 'formik';
import '../../_attributeInfo.scss';

class AddAttributeModal extends Component {
  state = {
    suggestions: Object.keys(this.props.suggestions).sort(),
  };

  render() {
    return (
      <Modal className="attribute-modal">
        <Formik
          initialValues={{ attributeValue: '', isUseNullAttribute: false }}
          validate={this.validate}
          onSubmit={this.onConfirm.bind(this)}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit} autoComplete="off">
              <ModalHeader>
                <h2>Override Default Source Attribute</h2>
              </ModalHeader>
              <ModalContent>
                <div className="knock-react-flex">
                  <div className="field-label">Source</div>
                  <div className="field-input">
                    <i className="fa fa-building" />{' '}
                    {this.props.marketingSource.name}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Default Attribute</div>
                  <div className="field-input">
                    {this.props.marketingSource.default_attribute ? (
                      <span>
                        <i className="fa fa-tags" />{' '}
                        {this.props.marketingSource.default_attribute}
                      </span>
                    ) : (
                      <span>
                        <i className="fa fa-tag" /> <em>None</em>
                      </span>
                    )}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Override With</div>
                  <div className="field-input">
                    <input
                      className="knock-react-input"
                      disabled={props.values.isUseNullAttribute}
                      name="attributeValue"
                      placeholder="Custom source attribute"
                      onChange={props.handleChange}
                      type="text"
                      value={props.values.attributeValue}
                    />
                    {props.errors.attributeValue && (
                      <span className="knock-react-form-hint knock-react-form-hint-error">
                        {props.errors.attributeValue}
                      </span>
                    )}
                    <input
                      checked={props.values.isUseNullAttribute}
                      name="isUseNullAttribute"
                      onClick={this.handleNullAttributeToggle.bind(this, props)}
                      onChange={props.handleChange}
                      type="checkbox"
                    />
                    No source attribute
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Suggestions</div>
                  <div className="field-input">
                    {this.state.suggestions.length ? (
                      this.state.suggestions.map((suggestion, i) => {
                        return (
                          <a
                            className="mRight10"
                            key={`suggestion-${i}`}
                            onClick={this.loadSuggestion.bind(
                              this,
                              suggestion,
                              props
                            )}
                            href="#"
                          >
                            {suggestion}
                          </a>
                        );
                      })
                    ) : (
                      <em>None</em>
                    )}
                  </div>
                </div>
              </ModalContent>
              <ModalFooter>
                <button
                  className="btn-md btn-primary"
                  onClick={this.onCancel.bind(this)}
                  type="button"
                >
                  <i className="fa fa-lg fa-times-circle" /> Cancel
                </button>
                <button className="btn-md btn-success" type="submit">
                  <i className="fa fa-lg fa-check-circle" /> Override Default
                  Attribute
                </button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      </Modal>
    );
  }

  handleNullAttributeToggle(formProps) {
    const {
      values: { isUseNullAttribute },
    } = formProps;

    if (!isUseNullAttribute) {
      formProps.setFieldValue('attributeValue', '');
    }
  }

  loadSuggestion(suggestion, formProps) {
    if (!formProps.values.isUseNullAttribute) {
      formProps.setFieldValue('attributeValue', suggestion);
    }
  }

  validate(values) {
    const errors = {};
    const isInputRequired =
      !values.isUseNullAttribute && !values.attributeValue.trim();

    if (isInputRequired) {
      errors.attributeValue = 'Required';
    }

    return errors;
  }

  onConfirm(values) {
    const attributeValue = values.isUseNullAttribute
      ? null
      : values.attributeValue;

    this.props.createAttribute(this.props.marketingSource.id, attributeValue);
  }

  onCancel() {
    this.props.toggleModal(false);
  }
}

AddAttributeModal.propTypes = {
  createAttribute: PropTypes.func,
  marketingSource: PropTypes.object,
  suggestions: PropTypes.object,
  toggleModal: PropTypes.func,
};

export default AddAttributeModal;
